/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Sparkle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z"
        opacity={0.2}
      />
      <Path
        d="M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={176}
        y1={16}
        x2={176}
        y2={64}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={200}
        y1={40}
        x2={152}
        y2={40}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={224}
        y1={72}
        x2={224}
        y2={104}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={240}
        y1={88}
        x2={208}
        y2={88}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Sparkle;
